import React from "react";

const VerifiedCircleIcon = ({ className = "w-6 h-6" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        opacity="0.3"
        cx="12"
        cy="12"
        r="11"
        fill="currentColor"
        fillOpacity="0.7"
      />
      <circle cx="12" cy="12" r="8" fill="currentColor" />
      <path
        d="M11.1851 15.2205C10.7607 15.6496 10.0676 15.6496 9.64321 15.2205L7.6573 13.2127C7.29326 12.8446 7.29365 12.252 7.65817 11.8844V11.8844C8.02792 11.5116 8.6309 11.5122 8.99985 11.8859L10.2122 13.1136C10.3233 13.2262 10.5051 13.2263 10.6163 13.1137L15 8.67821C15.3691 8.30475 15.972 8.30424 16.3417 8.67707V8.67707C16.7063 9.04472 16.7067 9.63745 16.3426 10.0056L11.1851 15.2205Z"
        fill="white"
      />
    </svg>
  );
};

export default VerifiedCircleIcon;
